import React, { useEffect, useState } from 'react';
import Button from '../ds/components/Button';
import { valorPara, AVISO_DATOS } from '../data/valor';
import { PLANES, recomendar, MOTIVO_TEXTO, VERSION_REGLAS } from '../data/planes';
import { evento, sesionId, VERSION_FLUJO } from '../lib/medicion';
import ResultadoRumbo from './ResultadoRumbo';

// 🟠 Texto del aviso: provisorio hasta que An lo defina (ver ESPECIFICACION.md §9).
const VERSION_AVISO = 'provisorio-2026-10-18';

const textoPlazo = (a) => {
  if (!a || !a.plazo) return 'Te escribiremos a la brevedad.';
  const dias = `${a.plazo} ${a.plazo === 1 ? 'día hábil' : 'días hábiles'}`;
  if (a.fuera_hasta) {
    const f = new Date(`${a.fuera_hasta}T12:00:00`);
    if (!Number.isNaN(f.getTime()) && f > new Date()) {
      return `Estamos fuera hasta el ${f.toLocaleDateString('es-AR', { day: 'numeric', month: 'long' })}. Te escribimos a partir de ese día, dentro de ${dias}.`;
    }
  }
  return `Te escribiremos dentro de ${dias}.`;
};

const PASOS_CAPACITACION = [
  ['Encuentro gratuito de 45 minutos', 'Para ver si te conviene, sin compromiso.'],
  ['Iniciación de 2 horas', 'Una primera práctica con tu propio caso.'],
  ['Programa de 4 semanas', 'En grupos chicos; cada persona se va con un asistente propio funcionando.'],
];

const CierreHome = ({ node, collected, escribimeHref, onNavigate, onRestart }) => {
  const valor = valorPara(collected);
  const { plan: sugerido, motivo } = recomendar(collected, node.id);
  const [elegido, setElegido] = useState(null);
  const [copiado, setCopiado] = useState(false);
  const [ajustes, setAjustes] = useState(undefined);
  const [form, setForm] = useState(false);
  const [estado, setEstado] = useState('libre'); // libre | enviando | ok | error
  const [datos, setDatos] = useState({ nombre: '', canal: 'whatsapp', dato: '', aviso: false });
  const pantalla = node.id;

  useEffect(() => {
    evento('resultado_visto', { pantalla, plan: sugerido });
    evento('valor_visto', { pantalla });
    let vivo = true;
    fetch('/.netlify/functions/ajustes').then(r => r.json()).then(a => { if (vivo) setAjustes(a); }).catch(() => { if (vivo) setAjustes(null); });
    return () => { vivo = false; };
  }, [pantalla, sugerido]);

  const copiar = async () => {
    try { await navigator.clipboard.writeText(valor.prompt); setCopiado(true); evento('prompt_copiado', { pantalla }); setTimeout(() => setCopiado(false), 2500); }
    catch { setCopiado(false); }
  };

  const abrirForm = () => { setForm(true); evento('contacto_abierto', { pantalla, plan: elegido || sugerido }); };
  const elegir = (id) => { setElegido(id); evento('plan_abierto', { pantalla, plan: id }); };

  const enviar = async (e) => {
    e.preventDefault();
    if (estado === 'enviando' || !datos.aviso) return;
    setEstado('enviando');
    const { businessName, rubroSugerido, ...resto } = collected || {};
    try {
      const r = await fetch('/.netlify/functions/contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: datos.nombre, canal: datos.canal, dato_contacto: datos.dato, aviso_aceptado: true, version_aviso: VERSION_AVISO,
          servicio: node.servicio || node.id, respuestas: { ...resto, negocio: businessName || '' },
          sesion_id: sesionId(), plan_sugerido: sugerido, plan_motivo: motivo, plan_elegido: elegido || undefined,
          version_flujo: VERSION_FLUJO, version_reglas: VERSION_REGLAS,
        }),
      });
      if (!r.ok) throw new Error('fallo');
      evento('contacto_enviado', { pantalla, plan: elegido || sugerido });
      setEstado('ok');
    } catch {
      evento('contacto_error', { pantalla });
      setEstado('error');
    }
  };

  const pausada = ajustes && ajustes.pausada;

  return (
    <div className="gh-cierre">
      <ResultadoRumbo node={node} collected={collected} />
      {node.navTo ? (
        <section className="gh-cierre__bloque" aria-labelledby="gh-c-valor">
          <h2 id="gh-c-valor" className="gh-cierre__titulo">Mirá cómo quedaría</h2>
          <div className="gh-puntos">{(node.bullets || []).map(b => <div key={b} className="gh-punto">{b}</div>)}</div>
          {node.priceNote && <p className="gh-nota">{node.priceNote}</p>}
          <div className="gh-acciones"><Button variant="solido" onClick={onNavigate}>Quiero verlo →</Button></div>
        </section>
      ) : (
      <section className="gh-cierre__bloque" aria-labelledby="gh-c-valor">
        <h2 id="gh-c-valor" className="gh-cierre__titulo">Para empezar hoy</h2>
        <dl className="gh-valor">
          <div><dt>Herramienta</dt><dd>{valor.herramienta}</dd></div>
          <div><dt>Primer paso</dt><dd>{valor.paso}</dd></div>
          <div>
            <dt>Prompt para copiar</dt>
            <dd>
              <span className="gh-prompt">{valor.prompt}</span>
              <button type="button" className="gh-sutil gh-copiar" onClick={copiar}>{copiado ? 'Copiado' : 'Copiar prompt'}</button>
            </dd>
          </div>
          {valor.listo && <div><dt>Listo cuando</dt><dd>{valor.listo}</dd></div>}
        </dl>
        <p className="gh-nota">{AVISO_DATOS}</p>
      </section>
      )}

      {node.academia ? (
        <section className="gh-cierre__bloque" aria-labelledby="gh-c-planes">
          <h2 id="gh-c-planes" className="gh-cierre__titulo">Cómo es la capacitación</h2>
          <ol className="gh-pasos">
            {PASOS_CAPACITACION.map(([t, d]) => <li key={t}><strong>{t}</strong> {d}</li>)}
          </ol>
        </section>
      ) : (
      <section className="gh-cierre__bloque" aria-labelledby="gh-c-planes">
        <h2 id="gh-c-planes" className="gh-cierre__titulo">Tres caminos</h2>
        <div className="gh-planes" role="group" aria-label="Planes">
          {PLANES.map(p => (
            <button
              key={p.id}
              type="button"
              className="gh-plan"
              aria-pressed={elegido === p.id}
              data-sugerido={sugerido === p.id}
              onClick={() => elegir(p.id)}
            >
              <span className="gh-plan__nombre">{p.nombre}</span>
              {sugerido === p.id && <span className="gh-plan__marca">Sugerido</span>}
              <span className="gh-plan__texto">{p.resumen}</span>
              <ul className="gh-plan__items">{p.items.map(t => <li key={t}>{t}</li>)}</ul>
            </button>
          ))}
        </div>
        {sugerido !== 'neutro' && <p className="gh-nota">{MOTIVO_TEXTO[motivo]} Podés elegir el que prefieras.</p>}
      </section>
      )}

      <section className="gh-cierre__bloque" aria-labelledby="gh-c-cierre">
        <h2 id="gh-c-cierre" className="gh-cierre__titulo">Sigamos hablando</h2>
        {estado === 'ok' ? (
          <p className="gh-cierre__ok" role="status">Gracias, {datos.nombre.split(' ')[0]}. {textoPlazo(ajustes)}</p>
        ) : pausada ? (
          <p className="gh-nota">Por ahora no estamos recibiendo consultas por acá.{ajustes.mensaje ? ` ${ajustes.mensaje}` : ''}</p>
        ) : !form ? (
          <div className="gh-acciones">
            <Button variant="solido" onClick={abrirForm}>Dejar mi contacto</Button>
            <a
              href={escribimeHref}
              target="_blank"
              rel="noopener noreferrer"
              className="gh-sutil"
              onClick={() => evento('escribime_tocado', { pantalla, plan: elegido || sugerido })}
            >
              Prefiero escribirte yo →
            </a>
          </div>
        ) : (
          <form className="gh-contacto" onSubmit={enviar}>
            <label>Tu nombre
              <input className="gh-input" required maxLength={120} value={datos.nombre} autoComplete="name" onChange={e => setDatos({ ...datos, nombre: e.target.value })} />
            </label>
            <fieldset className="gh-canal">
              <legend>¿Por dónde te escribimos?</legend>
              <label><input type="radio" name="canal" checked={datos.canal === 'whatsapp'} onChange={() => setDatos({ ...datos, canal: 'whatsapp' })} /> WhatsApp</label>
              <label><input type="radio" name="canal" checked={datos.canal === 'mail'} onChange={() => setDatos({ ...datos, canal: 'mail' })} /> Mail</label>
            </fieldset>
            <label>{datos.canal === 'mail' ? 'Tu mail' : 'Tu número, con código de área'}
              <input
                className="gh-input" required maxLength={160} value={datos.dato}
                type={datos.canal === 'mail' ? 'email' : 'tel'} autoComplete={datos.canal === 'mail' ? 'email' : 'tel'}
                onChange={e => setDatos({ ...datos, dato: e.target.value })}
              />
            </label>
            <label className="gh-aviso">
              <input type="checkbox" checked={datos.aviso} onChange={e => setDatos({ ...datos, aviso: e.target.checked })} />
              <span>Acepto que GUIA guarde mis respuestas y el recorrido de esta consulta junto con mi contacto, solo para responderme. Me escriben una vez; no me suman a ninguna lista. <a href="/privacidad" target="_blank" rel="noopener noreferrer">Más sobre mis datos</a>.</span>
            </label>
            {estado === 'error' && <p className="gh-nota" role="alert">No pudimos guardar tus datos. Probá de nuevo o <a href={escribimeHref} target="_blank" rel="noopener noreferrer" onClick={() => evento('escribime_tocado', { pantalla })}>escribinos por WhatsApp</a>.</p>}
            <div className="gh-acciones">
              <Button variant="solido" type="submit" disabled={!datos.aviso || estado === 'enviando'}>{estado === 'enviando' ? 'Enviando…' : 'Enviar'}</Button>
            </div>
            <p className="gh-nota">{textoPlazo(ajustes)}</p>
          </form>
        )}
      </section>

      <button onClick={onRestart} className="gh-sutil">← nueva consulta</button>
    </div>
  );
};

export default CierreHome;
